export default __webpack_public_path__ + "static/security-robust-b4f3aa737c5560b05f4972a03c9fe2ef.svg";